'use strict';

// Import Libraries
import React, { useEffect, useState } from 'react';

import classNames from 'classnames';
import screenAndStyle from '../_utils/screen-and-style';
// Import JSX Modules
import MobileSortOption from './mobile-sort-option';
// -----------------------------------------------------------
//  MobileSort
// -----------------------------------------------------------
const MobileSort = ({value, onChange}) => {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    if (screenAndStyle.isBootstrapXS()) {
      setCollapsed(true)
    }
  }, []);

  const toggleCollapse = () => {
    setCollapsed(prevState => !prevState);
  };
  const options = [{
    value: 'best-sellers',
    title: 'Best sellers'
  },{
    value: 'price-low-to-high',
    title: 'Price: low to high'
  },{
    value: 'price-high-to-low',
    title: 'Price: high to low'
  },{
    value: 'new',
    title: 'New'
  },{
    value: 'featured',
    title: 'Featured'
  }];

  const title = options.reduce((memo, option) => {
    return option.value == value ? option.title : memo;
  }, '');

  const renderOptions = () => {
    if (collapsed) {
      return null;
    }

    return (
      <div>
        <ul className="list-unstyled">
        {
          options.map((option, i) => {
            return <MobileSortOption { ...option }
                                      key={`${i}${value === option.value}`}
                                      selected={ value === option.value }
                                      onChange={ onChange } />
          })
        }
        </ul>
      </div>
    );
  };

  return (
    <section className={ classNames('accordion-entry accordion-entry-mobile-horizontal-padding', { collapsed: collapsed }) }>
      <button
        className="p-2 border-0 bg-white w-100 text-left"
        onClick={ toggleCollapse }
        aria-label='Sort'
        aria-expanded={!collapsed}
        type='button'>
        Sort
      </button>
      <span className={ classNames('list-selected-options-filters', {'d-none': !collapsed}) }>{ title }</span>
      {renderOptions()}
    </section>
  );
};

export default MobileSort;
